import { render, staticRenderFns } from "./ChargesTable.vue?vue&type=template&id=0b72bd89&scoped=true"
import script from "./ChargesTable.vue?vue&type=script&lang=js"
export * from "./ChargesTable.vue?vue&type=script&lang=js"
import style0 from "./ChargesTable.vue?vue&type=style&index=0&id=0b72bd89&prod&lang=scss"
import style1 from "./ChargesTable.vue?vue&type=style&index=1&id=0b72bd89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72bd89",
  null
  
)

export default component.exports